import ResetPasswordForm from '@/domains/auth/components/ResetPasswordForm';

export default function ResetPasswordPage() {
  return <ResetPasswordForm />;
}
